
export const translations = {
  en: {
    // Navigation
    nav_home: "Home",
    nav_jaap: "Jaap",
    nav_sangha: "Sangha",
    nav_scanner: "Naam-Lekhan Scanner",
    nav_progress: "Progress",
    nav_admin: "Admin",
    nav_menu_seva: "Menu & Seva",
    nav_ai_vani: "AI Sant Vani",
    nav_leela_chintan: "Leela Chintan",
    nav_insights: "Sadhana Insights",
    nav_ebooks: "Divine E-books",
    nav_audios: "Satsang Audio",
    nav_videos: "Divine Videos",
    nav_poems: "Divine Poetry",
    nav_blogs: "Divine Blogs",
    nav_about: "About Us",
    nav_contact: "Contact Us",
    nav_bhagwatam: "Bhagwatam",
    nav_gita: "Bhagwad Gita",
    nav_notes: "My Notes",
    nav_favorites: "My Favorites",
    nav_atma_parikshan: "Atma Parikshan",
    nav_shloka: "Shloka of the Day",
    nav_ekadashi: "Ekadashi Calendar",
    nav_buy_books: "Buy Books",
    
    // Header & Global
    header_reminder: "Divine Reminder",
    header_notifications: "Notifications",
    header_theme_light: "Light Mode",
    header_theme_dark: "Dark Mode",
    header_lang: "Change Language",
    profile: "Profile",
    guest_devotee: "Guest Devotee",
    guest_mode: "Guest Mode",
    guest_signup: "Sign Up",
    
    // Quick Access Bar
    quick_ebooks: "Divine E-books",
    quick_audios: "Satsang Audio",
    quick_videos: "Divine Videos",
    quick_ai_vani: "AI Sant Vani",
    quick_blogs: "Divine Blogs",
    
    // Notifications
    notif_title: "Divine Messages",
    notif_empty: "No new messages from the divine realm.",
    notif_mark_read: "Mark all read",
    notif_new: "New",
    
    // Jaap Interface
    jaap_type: "Type",
    jaap_lekhani: "Lekhani",
    jaap_likhit: "Likhit",
    jaap_smaran: "Smaran",
    jaap_vani: "Vani", 
    jaap_mala_progress: "Mala Progress",
    jaap_ledger: "Sacred Ledger",
    jaap_names: "Names",
    jaap_patience: "Patience Devotee... Focus on the word.",
    jaap_opening: "Opening...",
    jaap_vani_off: "Vani Off",
    vani_banner_title: "Voice Detection Beta",
    vani_banner_text: "Not 100% accurate yet \u2022 Count may vary slightly \u2022 Best results in quiet place \u2022 Chrome recommended \u2022 Speak clearly and slowly",
    jaap_sadhak_mode: "Sadhak Mode",
    jaap_change: "Change",
    
    // Sidebar Menu Items
    sidebar_sadhana_features: "Sadhana Features",
    sidebar_badges: "Badges",
    sidebar_community: "Community",
    sidebar_reminders: "Reminders",
    sidebar_guidelines: "Sadhana Guidelines",
    sidebar_guideline_1: "Bathe before starting Jaap.",
    sidebar_guideline_2: "Use Braj Raj Tilak for focus.",
    sidebar_guideline_3: "Maintain silence during the session.",
    sidebar_guideline_4: "Aim for 108 names per session.",
    
    // Dashboard
    dash_target_title: "Monthly Sadhana Targets",
    dash_min_goal: "Minimum Goal",
    dash_per_mantra: "per Mantra",
    dash_limitless: "Maximum: No Limit. Sky is the limit.",
    dash_monthly_prog: "Monthly Progress",
    dash_beyond: "Beyond Limits",
    dash_achieved: "Achieved",
    dash_streak: "Streak",
    dash_streak_sub: "Consistent devotion",
    dash_daily_avg: "Daily Avg",
    dash_avg_sub: "Names per day",
    dash_total_seva: "Total Seva",
    dash_seva_sub: "Cumulative names written",
    dash_weekly: "Weekly Activity",
    dash_history: "Writing history",
    dash_days: "days",
    
    // Auth Screen
    auth_welcome: "Welcome",
    auth_welcome_back: "Welcome Back",
    auth_join: "Join the Divine Family",
    auth_recover: "Recover Account",
    auth_method_id: "ID / Email",
    auth_method_mobile: "Mobile",
    auth_label_id: "Devotee ID / Email",
    auth_label_mobile: "Mobile Number",
    auth_label_key: "Secret Key",
    auth_placeholder_id: "Username or email",
    auth_placeholder_mobile: "10-digit mobile number",
    auth_btn_signin: "Sign In",
    auth_btn_join: "Join Bank",
    auth_btn_reset: "Reset Access",
    auth_new_devotee: "New devotee?",
    auth_already_member: "Already part of the bank?",
    auth_create: "Create Account",
    auth_login: "Login",
    auth_select_method: "Select login method",
    auth_email_otp: "Email OTP",
    auth_phone_otp: "Phone OTP",
    auth_google: "Google",
    auth_continue_guest: "Continue as Guest",
    auth_im_new: "I'm New",
    auth_create_account: "Create new account",
    auth_already_member_login: "Already Member",
    auth_login_account: "Login to your account",
    auth_back: "Back",
    auth_or: "or",
    auth_ram_ram: "Ram Ram",
    auth_please_select: "Please select",
    auth_jai_shri_ram: "Jai Shri Ram",
    
    // Onboarding
    onboard_welcome: "Welcome!",
    onboard_skip: "Skip",
    onboard_next: "Next",
    onboard_jaap_title: "Ram Naam Jaap",
    onboard_jaap_desc: "Write, remember and chant the divine names of God",
    
    // Hall of Fame & Certificates
    hall_title: "Hall of Fame",
    hall_sub: "Honoring the dedicated souls.",
    hall_rank: "Rank",
    hall_devotee: "Devotee",
    hall_deposits: "Deposits",
    cert_title: "My Siddhi Achievements",
    cert_sub: "Unlock certificates by reaching 30 Lakh milestones.",
    cert_download: "Download Certificate",
    cert_locked: "Locked",
    
    // Nidhi OCR
    nidhi_title: "Nidhi OCR",
    nidhi_sub: "Convert handwritten devotion to digital deposits.",
    nidhi_capture: "Capture Page",
    nidhi_snap: "Snap a photo of your notebook",
    nidhi_guide: "Scanning Guide",
    nidhi_btn_scan: "Initiate Divine Scan",
    nidhi_btn_deposit: "Deposit to Bank",

    // Sangha
    sangha_title: "Akhand Virtual Sangha",
    sangha_sub: "Sadhana is powerful when done alone, but it becomes eternal when done together in a Sangha.",
    sangha_active_now: "Active Now",
    sangha_collective_jaap: "Collective Jaap",
    sangha_sadhaks: "Sadhaks",
    sangha_ethics: "Sangha Ethics",
    sangha_ethic_1: "Maintain inner silence while in the room.",
    sangha_ethic_2: "Every tap adds to the global divine energy.",
    sangha_ethic_3: "The counter reflects real-time contributions.",
    sangha_tap_contribute: "Tap to Contribute",
    sangha_my_contribution: "My Contribution",
    sangha_session_gain: "Session Gain",
    sangha_activity: "Sangha Activity",
    sangha_waiting: "Waiting for vibrations from other devotees...",
    sangha_mod_active: "Mod Active",
    sangha_eternal_total: "Eternal Collective Total",
    sangha_feed_joined: "joined the Sangha",
    sangha_feed_chanting: "is chanting with focus",
    sangha_feed_offered: "offered prayers",
    sangha_feed_milestone: "reached a milestone",
    
    // Profile
    profile_edit: "Edit Profile",
    profile_security: "Security",
    profile_signout: "Sign Out",
    profile_joined: "Joined",
    profile_breakdown: "Sadhana Breakdown",
    profile_bio: "Spiritual Bio & Aspiration",
    profile_save: "Save",
    
    // Videos
    videos_title: "Divine Videos",
    videos_subtitle: "Satsang, bhajan, pravachan and aarti videos",
    videos_search: "Search videos...",
    videos_all: "All",
    videos_manage: "Manage Videos",
    videos_recently_watched: "Recently Watched",
    videos_continue_watching: "Continue Watching",
    
    // Audios
    audios_title: "Satsang Audio",
    audios_subtitle: "Listen to divine discourses & bhajans",
    audios_all: "All Recordings",
    
    // Blogs
    blogs_title: "Divine Wisdom Blog",
    blogs_subtitle: "Spiritual insights, teachings, and stories for your sadhana journey",
    blogs_search: "Search articles...",
    
    // Ebooks
    ebooks_title: "Divine E-Library",
    ebooks_subtitle: "Read sacred flipbooks to enrich your spiritual journey.",
    
    // Common
    common_save: "Save",
    common_cancel: "Cancel",
    common_loading: "Loading...",
    common_radhe: "Radhe Radhe...",
    common_error: "Something went wrong.",
    common_refresh: "Pull for Darshan",
    common_release: "Release for Blessing",
    common_receiving: "Receiving Grace...",
    common_all: "All",
    common_search: "Search",
    common_download: "Download Image",
    common_share: "Share",
    common_views: "views",
    common_likes: "likes",
    
    // Nitya Seva
    nitya_title: "Nitya Seva",
    nitya_sub: "Perform daily sacred altar service with devotion.",
    nitya_dust_warn: "Altar needs cleaning!",
    nitya_clean_btn: "Clean",
    nitya_lit: "Lit",
    nitya_light_diya: "Light Diya",
    nitya_bell: "Bell",
    nitya_offer_flower: "Flower",
    nitya_offer_tulsi: "Tulsi",
    
    // Shloka
    shloka_today: "Shloka of Today",
    shloka_download: "Download Image",
    
    // Footer
    footer_company: "Golok Prem Ras Technology"
  },
  hi: {
    // Navigation
    nav_home: "गृह",
    nav_jaap: "जाप",
    nav_sangha: "संघ",
    nav_scanner: "नाम-लेखन स्कैनर",
    nav_progress: "प्रगति",
    nav_admin: "एडमिन",
    nav_menu_seva: "मेनू और सेवा",
    nav_ai_vani: "एआई संत वाणी",
    nav_leela_chintan: "लीला चिंतन",
    nav_insights: "साधना अंतर्दृष्टि",
    nav_ebooks: "दिव्य ई-पुस्तकें",
    nav_audios: "सत्संग ऑडियो",
    nav_videos: "दिव्य वीडियो",
    nav_poems: "दिव्य काव्य",
    nav_blogs: "दिव्य ब्लॉग",
    nav_about: "हमारे बारे में",
    nav_contact: "संपर्क करें",
    nav_bhagwatam: "भागवतम्",
    nav_gita: "भगवद गीता",
    nav_notes: "मेरे नोट्स",
    nav_favorites: "मेरे पसंदीदा",
    nav_atma_parikshan: "आत्म-परीक्षण",
    nav_shloka: "आज का श्लोक",
    nav_ekadashi: "एकादशी कैलेंडर",
    nav_buy_books: "पुस्तकें खरीदें",
    
    // Header & Global
    header_reminder: "दिव्य अनुस्मारक",
    header_notifications: "सूचनाएं",
    header_theme_light: "लाइट मोड",
    header_theme_dark: "डार्क मोड",
    header_lang: "भाषा बदलें",
    profile: "प्रोफ़ाइल",
    guest_devotee: "अतिथि भक्त",
    guest_mode: "अतिथि मोड",
    guest_signup: "साइन अप करें",
    
    // Quick Access Bar
    quick_ebooks: "दिव्य ई-पुस्तकें",
    quick_audios: "सत्संग ऑडियो",
    quick_videos: "दिव्य वीडियो",
    quick_ai_vani: "एआई संत वाणी",
    quick_blogs: "दिव्य ब्लॉग",
    
    // Notifications
    notif_title: "दिव्य संदेश",
    notif_empty: "दिव्य लोक से कोई नया संदेश नहीं।",
    notif_mark_read: "सभी पढ़ें",
    notif_new: "नया",
    
    // Jaap Interface
    jaap_type: "टाइप",
    jaap_lekhani: "लेखनी",
    jaap_likhit: "लिखित",
    jaap_smaran: "स्मरण",
    jaap_vani: "वाणी", 
    jaap_mala_progress: "माला प्रगति",
    jaap_ledger: "पवित्र बही",
    jaap_names: "नाम",
    jaap_patience: "धैर्य रखें... शब्द पर ध्यान दें।",
    jaap_opening: "खुल रहा है...",
    jaap_vani_off: "वाणी बंद",
    vani_banner_title: "वाणी पहचान बीटा",
    vani_banner_text: "अभी 100% सटीक नहीं है \u2022 गिनती में थोड़ा अंतर आ सकता है \u2022 शांत जगह पर सर्वोत्तम परिणाम \u2022 Chrome अनुशंसित \u2022 स्पष्ट और धीरे बोलें",
    jaap_sadhak_mode: "साधक मोड",
    jaap_change: "बदलें",
    
    // Sidebar Menu Items
    sidebar_sadhana_features: "साधना सुविधाएं",
    sidebar_badges: "बैज",
    sidebar_community: "समूह",
    sidebar_reminders: "रिमाइंडर",
    sidebar_guidelines: "साधना नियम",
    sidebar_guideline_1: "जाप से पहले स्नान करें।",
    sidebar_guideline_2: "ध्यान के लिए ब्रज राज तिलक लगाएं।",
    sidebar_guideline_3: "सत्र के दौरान मौन रखें।",
    sidebar_guideline_4: "प्रत्येक सत्र में 108 नाम लिखें।",
    
    // Dashboard
    dash_target_title: "मासिक साधना लक्ष्य",
    dash_min_goal: "न्यूनतम लक्ष्य",
    dash_per_mantra: "प्रति मंत्र",
    dash_limitless: "अधिकतम: कोई सीमा नहीं। आकाश ही सीमा है।",
    dash_monthly_prog: "मासिक प्रगति",
    dash_beyond: "सीमाओं के परे",
    dash_achieved: "प्राप्त किया",
    dash_streak: "नियमितता",
    dash_streak_sub: "निरंतर भक्ति",
    dash_daily_avg: "दैनिक औसत",
    dash_avg_sub: "प्रति दिन नाम",
    dash_total_seva: "कुल सेवा",
    dash_seva_sub: "कुल लिखित नाम",
    dash_weekly: "साप्ताहिक गतिविधि",
    dash_history: "इतिहास लिख रहे हैं",
    dash_days: "दिन",
    
    // Auth Screen
    auth_welcome: "स्वागत है",
    auth_welcome_back: "पुनः स्वागत है",
    auth_join: "दिव्य परिवार में शामिल हों",
    auth_recover: "खाता पुनः प्राप्त करें",
    auth_method_id: "आईडी / ईमेल",
    auth_method_mobile: "मोबाइल",
    auth_label_id: "भक्त आईडी / ईमेल",
    auth_label_mobile: "मोबाइल नंबर",
    auth_label_key: "गुप्त कुंजी",
    auth_placeholder_id: "यूजरनेम या ईमेल",
    auth_placeholder_mobile: "10-अंकीय मोबाइल नंबर",
    auth_btn_signin: "साइन इन",
    auth_btn_join: "बैंक से जुड़ें",
    auth_btn_reset: "एक्सेस रीसेट करें",
    auth_new_devotee: "नया भक्त?",
    auth_already_member: "पहले से सदस्य हैं?",
    auth_create: "खाता बनाएं",
    auth_login: "लॉगिन करें",
    auth_select_method: "लॉगिन का तरीका चुनें",
    auth_email_otp: "ईमेल ओटीपी",
    auth_phone_otp: "फोन ओटीपी",
    auth_google: "गूगल",
    auth_continue_guest: "अतिथि के रूप में जारी रखें",
    auth_im_new: "नया हूँ",
    auth_create_account: "नया खाता बनाएं",
    auth_already_member_login: "पहले से हूँ",
    auth_login_account: "अपने खाते में लॉगिन करें",
    auth_back: "वापस",
    auth_or: "या",
    auth_ram_ram: "राम राम",
    auth_please_select: "कृपया चुनें",
    auth_jai_shri_ram: "जय श्री राम",
    
    // Onboarding
    onboard_welcome: "स्वागत है!",
    onboard_skip: "छोड़ें",
    onboard_next: "आगे बढ़ें",
    onboard_jaap_title: "राम नाम जाप",
    onboard_jaap_desc: "भगवान् के दिव्य नामों को लिखें, याद करें और जपें",
    
    // Hall of Fame & Certificates
    hall_title: "हॉल ऑफ फेम",
    hall_sub: "समर्पित आत्माओं का सम्मान।",
    hall_rank: "रैंक",
    hall_devotee: "भक्त",
    hall_deposits: "जमा राशि",
    cert_title: "मेरी सिद्धि उपलब्धियां",
    cert_sub: "30 लाख के पड़ाव पर पहुंचकर प्रमाणपत्र अनलॉक करें।",
    cert_download: "प्रमाणपत्र डाउनलोड करें",
    cert_locked: "लॉक्ड",
    
    // Nidhi OCR
    nidhi_title: "निधि ओसीआर",
    nidhi_sub: "हस्तलिखित भक्ति को डिजिटल जमा राशि में बदलें।",
    nidhi_capture: "पेज कैप्चर करें",
    nidhi_snap: "अपनी नोटबुक की फोटो लें",
    nidhi_guide: "स्कैनिंग गाइड",
    nidhi_btn_scan: "दिव्य स्कैन शुरू करें",
    nidhi_btn_deposit: "बैंक में जमा करें",

    // Sangha
    sangha_title: "अखंड वर्चुअल संघ",
    sangha_sub: "अकेले की साधना शक्तिशाली है, लेकिन संघ में यह शाश्वत हो जाती है।",
    sangha_active_now: "अभी सक्रिय",
    sangha_collective_jaap: "सामूहिक जाप",
    sangha_sadhaks: "साधक",
    sangha_ethics: "संघ के नियम",
    sangha_ethic_1: "कक्ष में रहते हुए आंतरिक मौन बनाए रखें।",
    sangha_ethic_2: "हर एक स्पर्श वैश्विक दिव्य ऊर्जा में जुड़ता है।",
    sangha_ethic_3: "काउंटर वास्तविक समय के योगदान को दर्शाता है।",
    sangha_tap_contribute: "योगदान के लिए स्पर्श करें",
    sangha_my_contribution: "मेरा योगदान",
    sangha_session_gain: "सत्र लाभ",
    sangha_activity: "संघ की गतिविधि",
    sangha_waiting: "अन्य भक्तों के कंपन की प्रतीक्षा है...",
    sangha_mod_active: "मॉड सक्रिय",
    sangha_eternal_total: "शाश्वत सामूहिक कुल",
    sangha_feed_joined: "संघ में शामिल हुए",
    sangha_feed_chanting: "एकाग्रता से जाप कर रहे हैं",
    sangha_feed_offered: "प्रार्थना अर्पित की",
    sangha_feed_milestone: "एक पड़ाव पर पहुंचे",
    
    // Profile
    profile_edit: "प्रोफ़ाइल बदलें",
    profile_security: "सुरक्षा",
    profile_signout: "लॉग आउट",
    profile_joined: "जुड़ने की तिथि",
    profile_breakdown: "साधना विवरण",
    profile_bio: "आध्यात्मिक परिचय और संकल्प",
    profile_save: "सहेजें",
    
    // Videos
    videos_title: "दिव्य वीडियो",
    videos_subtitle: "सत्संग, भजन, प्रवचन और आरती के वीडियो",
    videos_search: "वीडियो खोजें...",
    videos_all: "सभी",
    videos_manage: "वीडियो प्रबंधित करें",
    videos_recently_watched: "हाल में देखे गए",
    videos_continue_watching: "देखना जारी रखें",
    
    // Audios
    audios_title: "सत्संग ऑडियो",
    audios_subtitle: "दिव्य प्रवचन और भजन सुनें",
    audios_all: "सभी रिकॉर्डिंग",
    
    // Blogs
    blogs_title: "दिव्य ज्ञान ब्लॉग",
    blogs_subtitle: "आपकी साधना यात्रा के लिए आध्यात्मिक अंतर्दृष्टि, शिक्षाएं और कहानियां",
    blogs_search: "लेख खोजें...",
    
    // Ebooks
    ebooks_title: "दिव्य ई-पुस्तकालय",
    ebooks_subtitle: "अपनी आध्यात्मिक यात्रा को समृद्ध करने के लिए पवित्र पुस्तकें पढ़ें।",
    
    // Common
    common_save: "सहेजें",
    common_cancel: "रद्द करें",
    common_loading: "लोड हो रहा है...",
    common_radhe: "राधे राधे...",
    common_error: "कुछ गलत हो गया।",
    common_refresh: "दर्शन के लिए खींचें",
    common_release: "आशीर्वाद के लिए छोड़ें",
    common_receiving: "कृपा प्राप्त हो रही है...",
    common_all: "सभी",
    common_search: "खोजें",
    common_download: "इमेज डाउनलोड करें",
    common_share: "साझा करें",
    common_views: "दृश्य",
    common_likes: "पसंद",
    
    // Nitya Seva
    nitya_title: "नित्य सेवा",
    nitya_sub: "भक्ति से दैनिक पवित्र वेदी सेवा करें।",
    nitya_dust_warn: "वेदी को सफाई की आवश्यकता है!",
    nitya_clean_btn: "सफाई",
    nitya_lit: "जल रहा",
    nitya_light_diya: "दीपक जलाएं",
    nitya_bell: "घंटी",
    nitya_offer_flower: "फूल",
    nitya_offer_tulsi: "तुलसी",
    
    // Shloka
    shloka_today: "आज का श्लोक",
    shloka_download: "इमेज डाउनलोड करें",
    
    // Footer
    footer_company: "गोलोक प्रेम रस टेक्नोलॉजी"
  }
};
